import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { getClients } from '../../actions/client-actions';
import { BsFillTrashFill } from "react-icons/bs";
import { searchListQuery } from '../../actions/global-actions';
import Paginator from '../../components/paginator/paginator';

function ClientsList(){
    const currentLink = "/clientes";
    const dispatch = useDispatch();
    const [clients, setClients] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [skip, setSkip] = useState(0);
    const [searchData, setSearchData] = useState({
        isSearching: false,
        value: ''
    });
    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log(data);

                setClients(data.data);

                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }

        if (loadData) {
            setLoadData(false);
            setClients([]);
            if (searchData.isSearching) {
                dispatch( searchListQuery( 'client', searchData.value, getFunction, skip, user.token ) );
            } else {
                dispatch( getClients( skip, getFunction, user.token ) );
            }
        }
    }, [loadData, dispatch, user.token, skip, searchData, paginatorData ]);

    const searchFunction = (event) => {
        let value = event.target.value;
        if (value.length > 2) {
            stockPaginator();
            setSearchData({
                isSearching: true,
                value
            });
            setLoadData(true);
        } else {
            if (value.length === 0) {
                stockPaginator();
                setSearchData({
                    isSearching: false,
                    value: ''
                });
                setLoadData(true);
            }
        }
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }
    
    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Clientes</h1>
                <div className="d-flex justify-content-between">
                    <div className="d-flex w-50">
                        <input className="input-field w-75" type="text" onChange={searchFunction} placeholder="Buscar un cliente por nombre, apellido o documento"/>
                    </div>
                    <Link to={`${currentLink}/nuevo`} className="primary-button">Añadir nuevo cliente +</Link>
                </div>
                <div className="w-100 d-flex justify-content-between my-4">
                    <span className='align-self-center'>Clientes: <b>{paginatorData.totalitems}</b></span>
                </div>
                <table className="list-table mb-4">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Cliente</th>
                            <th>Tipo Cliente</th>
                            <th>Correo</th>
                            <th>Tipo doc</th>
                            <th>Documento</th>
                            { user.userType === 'Administrador'?
                                <th></th>
                            :
                                null
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {clients.map((client, index) => (
                            <tr key={index}>
                                <td> <Link to={`/clientes/editar/${client._id}`} key={client._id}>{ (index+1) + skip }</Link> </td>
                                <td> <Link to={`/clientes/editar/${client._id}`} key={client._id}>{client.firstName} {client.lastName}</Link> </td>
                                <td> <Link to={`/clientes/editar/${client._id}`} key={client._id}>{client.clientType === 'natural'? 'Persona Natural' : 'Persona Jurídica'}</Link> </td>
                                <td> <Link to={`/clientes/editar/${client._id}`} key={client._id}>{client.email}</Link> </td>
                                <td> <Link to={`/clientes/editar/${client._id}`} key={client._id}>{client.documentType}</Link> </td>
                                <td> <Link to={`/clientes/editar/${client._id}`} key={client._id}>{client.document}</Link> </td>
                                { user.userType === 'Administrador'?
                                    <td>
                                        <BsFillTrashFill className='trash-icon' />
                                    </td>
                                :
                                    null
                                }
                            </tr> 
                        ))}
                    </tbody>
                </table>
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0? 
                    <Paginator skip={skip} data={paginatorData} setSkip={(n) => setSkip(n)} setLoadData={(need) => setLoadData(need)} />
                :
                    null
                }
            </div>
        </div>
    );
}

export default ClientsList;
  